import { makePathLogic } from '../../../logic/paths';
export var pathLogic = makePathLogic('ID_C_COUNTRY');
